import Button from '@mui/material/Button';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import MenuItem from '@mui/material/MenuItem';
import Popover from '@mui/material/Popover';
import Typography from '@mui/material/Typography';
import { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { changeLanguage } from 'app/store/i18nSlice';
import { constants } from '../../../constants';

const languages = [
  { id: 'en', title: 'English', flag: 'us' },
  { id: 'mx', title: 'Español', flag: 'mx' },
  // { id: 'co', title: 'Español', flag: 'co' },
];

function LanguageSwitcher(props) {
  const dispatch = useDispatch();
  const currentLanguageId = useSelector(({ i18n }) => i18n.language);
  const [currentLanguage, setCurrentLanguage] = useState(languages.find((lng) => lng.id === currentLanguageId) || languages[0]);
  const [menu, setMenu] = useState(null);

  useEffect(() => {
    const newLanguage = languages.find((lng) => lng.id === currentLanguageId) || languages[0];
    setCurrentLanguage(newLanguage);
  }, [currentLanguageId]);

  const langMenuClick = (event) => {
    setMenu(event.currentTarget);
  };

  const langMenuClose = () => {
    setMenu(null);
  };

  async function handleLanguageChange(lng) {
    try {
      await dispatch(changeLanguage(lng.id));
      await updateLanguagePreference(lng.id);
      setCurrentLanguage(lng);
      langMenuClose();
    } catch (error) {
      console.error('Error changing language:', error);
    }
  }

  const updateLanguagePreference = async (language_code) => {
    try {
      const lSData = JSON.parse(localStorage.getItem('persist:root'));
      const userData = JSON.parse(lSData.loadz_auth).AuthReducer.user;
      const user_id = userData.user_id;
      const usrLng = userData.language_code;

      if (language_code != usrLng) {
        const response = await fetch(`${constants.URLLOCAL}/language-translation/update-language-code`, {
          method: 'PUT',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ languageData: { language_code, user_id } }),
        });

        if (!response.ok) {
          console.error('Failed to update language on the backend');
        } else {
          const updatedUserData = { ...userData, language_code };
          const updatedAuthReducer = {
            ...JSON.parse(lSData.loadz_auth),
            AuthReducer: {
              ...JSON.parse(lSData.loadz_auth).AuthReducer,
              user: updatedUserData,
            },
          };
          localStorage.setItem('persist:root', JSON.stringify({ ...lSData, loadz_auth: JSON.stringify(updatedAuthReducer) }));
        }
      }
    } catch (error) {
      console.error('Error updating language on the backend:', error);
    }
  };

  return (
    <>
      <Button style={{ color: "black" }} className="h-40 w-64" onClick={langMenuClick}>
        <img
          className="mx-4 min-w-20"
          src={`assets/images/flags/${currentLanguage.flag}.png`}
          alt={currentLanguage.title}
        />

        <Typography style={{ color: "black" }} className="mx-4 font-Regular uppercase" color="textSecondary">
          {currentLanguage.id}
        </Typography>
      </Button>

      <Popover
        open={Boolean(menu)}
        anchorEl={menu}
        onClose={langMenuClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        classes={{
          paper: 'py-8',
        }}
      >
        {languages.map((lng) => (
          <MenuItem
            key={lng.id}
            onClick={async () => {
              await handleLanguageChange(lng);
            }}
          >
            <ListItemIcon className="min-w-40">
              <img
                className="min-w-20"
                src={`assets/images/flags/${lng.flag}.png`}
                alt={lng.title}
              />
            </ListItemIcon>
            <ListItemText primary={lng.title} />
          </MenuItem>
        ))}
      </Popover>
    </>
  );
}

export default LanguageSwitcher;
